var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewLogoDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 804,
    height: 200,
    viewBox: "0 0 804 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.06 23.53C60.03 23.53 70.59 34.09 70.59 47.06C70.59 60.03 60.03 70.59 47.06 70.59C34.09 70.59 23.53 60.03 23.53 47.06C23.53 34.09 34.09 23.53 47.06 23.53ZM47.06 0C21.07 0 0 21.07 0 47.06C0 73.05 21.07 94.12 47.06 94.12C73.05 94.12 94.12 73.05 94.12 47.06C94.12 21.07 73.05 0 47.06 0Z",
    fill: "#FF5349"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.12 105.88H0V129.41H94.12V105.88Z",
    fill: "#FF5349"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.12 176.47H0V200H94.12V176.47Z",
    fill: "#FF5349"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.12 141.18H0V164.71H94.12V141.18Z",
    fill: "#FF5349"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M366.56 0H329.82V195.94H366.56V0Z",
    fill: "#FFFFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M185.9 53.05C171.73 53.05 158.5 57.07 147.28 64.02V0H110.54V195.94H147.28V189.03C158.5 195.98 171.73 200 185.9 200C226.48 200 259.38 167.1 259.38 126.52C259.38 85.94 226.48 53.04 185.9 53.04V53.05ZM185.9 163.26C165.64 163.26 149.16 146.78 149.16 126.52C149.16 106.26 165.64 89.78 185.9 89.78C206.16 89.78 222.64 106.26 222.64 126.52C222.64 146.78 206.16 163.26 185.9 163.26Z",
    fill: "#FFFFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M729.76 89.79C750.02 89.79 766.5 106.27 766.5 126.53C766.5 146.79 750.02 163.27 729.76 163.27C709.5 163.27 693.02 146.79 693.02 126.53C693.02 106.27 709.5 89.79 729.76 89.79ZM729.76 53.05C689.18 53.05 656.28 85.95 656.28 126.53C656.28 167.11 689.18 200.01 729.76 200.01C770.34 200.01 803.24 167.11 803.24 126.53C803.24 85.95 770.34 53.05 729.76 53.05Z",
    fill: "#FFFFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M312.97 53.12H276.23V195.94H312.97V53.12Z",
    fill: "#FFFFFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M294.6 36.74C304.745 36.74 312.97 28.5155 312.97 18.37C312.97 8.22453 304.745 0 294.6 0C284.455 0 276.23 8.22453 276.23 18.37C276.23 28.5155 284.455 36.74 294.6 36.74Z",
    fill: "#FFFFFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M512.36 53.05C498.19 53.05 484.96 57.07 473.74 64.02V0H437V195.94H473.74V189.03C484.96 195.98 498.19 200 512.36 200C552.94 200 585.84 167.1 585.84 126.52C585.84 85.94 552.94 53.04 512.36 53.04V53.05ZM512.36 163.26C492.1 163.26 475.62 146.78 475.62 126.52C475.62 106.26 492.1 89.78 512.36 89.78C532.62 89.78 549.1 106.26 549.1 126.52C549.1 146.78 532.62 163.26 512.36 163.26Z",
    fill: "#FFFFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M639.43 53.12H602.69V195.94H639.43V53.12Z",
    fill: "#FFFFFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M621.06 36.74C631.205 36.74 639.43 28.5155 639.43 18.37C639.43 8.22453 631.205 0 621.06 0C610.914 0 602.69 8.22453 602.69 18.37C602.69 28.5155 610.914 36.74 621.06 36.74Z",
    fill: "#FFFFFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M401.78 200C411.925 200 420.15 191.775 420.15 181.63C420.15 171.485 411.925 163.26 401.78 163.26C391.635 163.26 383.41 171.485 383.41 181.63C383.41 191.775 391.635 200 401.78 200Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogoDark);
export default __webpack_public_path__ + "static/media/NewLogoDark.f1cd680cd0dc5d0885962979a2580fed.svg";
export { ForwardRef as ReactComponent };